import { useState } from "react";
import GlobalStyles, { CommonClasses } from "../../global/GlobalStyles";
import logo from "../../logo.png";
import { useNavigate } from "react-router-dom";
import api from "../../global/api";
import toast from "react-hot-toast";

const Signup = () => {
  const accessCode = process.env.REACT_APP_ACCESS_CODE;
  const [hasAccess, setHasAccess] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [accessInput, setAccessInput] = useState(["", "", "", ""]);
  const navigate = useNavigate();
  const data = {
    name,
    email,
    password,
    password_confirmation: confirmPassword,
  };

  const handleAccessCodeChange = (e, index) => {
    const value = e.target.value;
    if (value && !/^[0-9]$/.test(value)) return;

    const newAccessInput = [...accessInput];
    newAccessInput[index] = value;
    setAccessInput(newAccessInput);

    // Auto focus to next input
    if (value && index < 3) {
      document.getElementById(`access-code-${index + 1}`).focus();
    }
  };

  const handleAccessSubmit = (e) => {
    e.preventDefault();

    // Check if all 4 digits are filled
    const isComplete = accessInput.every((digit) => digit !== "");
    if (!isComplete) {
      toast.error("Please enter all 4 digits of the access code");
      return;
    }

    // Check if any digit is non-numeric (extra validation)
    const hasNonNumeric = accessInput.some((digit) => !/^[0-9]$/.test(digit));
    if (hasNonNumeric) {
      toast.error("Access code must contain only numbers");
      return;
    }

    const enteredCode = accessInput.join("");

    // Additional check for empty accessCode (environment variable not set)
    if (!accessCode) {
      toast.error("Invalid access code");
      return;
    }

    if (enteredCode === accessCode) {
      setHasAccess(true);
      toast.success("Access granted!");
    } else {
      toast.error("Invalid access code");
      // Optional: Clear the input fields on wrong attempt
      setAccessInput(["", "", "", ""]);
      // Focus back to first input
      document.getElementById("access-code-0")?.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post("/users", data);
      toast.success(response.data.message);
      navigate("/secured/login");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.log(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full h-screen bg-default2 bg-center bg-cover">
      <div className="w-full h-full bg-black/50 flex flex-col justify-center items-center gap-10 pt-16">
        {hasAccess ? (
          <form className={GlobalStyles.form} onSubmit={handleSubmit}>
            <div className="flex items-center gap-2">
              <img src={logo} alt="" className={GlobalStyles.formLogo} />
              <h2 className={GlobalStyles.formHeader}>Create account</h2>
            </div>
            <input
              type="text"
              placeholder="First name"
              className={GlobalStyles.input}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              type="text"
              placeholder="Email address"
              className={GlobalStyles.input}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              placeholder="Password"
              className={GlobalStyles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type={showPassword ? "text" : "password"}
            />
            <input
              placeholder="Confirm password"
              className={GlobalStyles.input}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              type={showPassword ? "text" : "password"}
            />
            <div className={`!flex-row-reverse ${GlobalStyles.seperator}`}>
              <div
                onClick={() => setShowPassword(!showPassword)}
                className={`${GlobalStyles.formLink} cursor-pointer`}
              >
                {showPassword ? "Hide password" : "Show password"}
              </div>
            </div>
            <button className={GlobalStyles.buttonFull}>
              {loading ? "Creating profile..." : "Sign up"}
            </button>
          </form>
        ) : (
          <form className={GlobalStyles.form} onSubmit={handleAccessSubmit}>
            <div className="flex items-center gap-2">
              <img src={logo} alt="" className={GlobalStyles.formLogo} />
              <h2 className={GlobalStyles.formHeader}>Enter access code</h2>
            </div>
            <div className="flex justify-center gap-2 mb-4">
              {[0, 1, 2, 3].map((index) => (
                <input
                  key={index}
                  id={`access-code-${index}`}
                  type="password"
                  inputMode="numeric"
                  maxLength={1}
                  className={`w-12 h-12 text-center text-sm text-primary ${CommonClasses.transition} ${CommonClasses.rounded} placeholder:text-primary/70 outline-none bg-primary/10`}
                  value={accessInput[index]}
                  onChange={(e) => handleAccessCodeChange(e, index)}
                  onKeyDown={(e) => {
                    if (
                      e.key === "Backspace" &&
                      !accessInput[index] &&
                      index > 0
                    ) {
                      document
                        .getElementById(`access-code-${index - 1}`)
                        .focus();
                    }
                  }}
                />
              ))}
            </div>
            <button type="submit" className={GlobalStyles.buttonFull}>
              Verify Code
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Signup;
